<div class="color-input-wrapper" #anchor [class.disabled]="isDisabled">
  <!-- Tupfer öffnet die Farbauswahl (Popover im Overlay). Schachbrett unter
       dem Wert, damit Transparenz sichtbar wird; ein Verlauf zeigt sich hier
       als Verlauf. -->
  <button
    #swatch
    type="button"
    class="color-swatch"
    aria-haspopup="dialog"
    [attr.aria-expanded]="open"
    [attr.aria-label]="'components.colorPicker.open' | translate"
    (click)="openPicker()"
    [disabled]="isDisabled"
  >
    <span class="color-swatch__fill" [style.background]="value"></span>
  </button>

  @if (gradientType) {
  <!-- Verlauf: kein Hex — ein kurzes Etikett, Bearbeiten im Popover. -->
  <button
    type="button"
    class="gradient-label"
    (click)="openPicker()"
    [disabled]="isDisabled"
  >
    {{ 'components.colorPicker.gradientLabel' | translate: { type: ('components.colorPicker.types.' + gradientType | translate) } }}
  </button>
  } @else {
  <input
    type="text"
    nbInput
    fullWidth
    class="hex-input"
    spellcheck="false"
    [value]="hexInput"
    (input)="onHexInput($event)"
    [disabled]="isDisabled"
    maxlength="9"
  />
  }
</div>
